import { render } from "./ContinueAsGuestAccountBenefitList.vue?vue&type=template&id=6708bf83"
import script from "./ContinueAsGuestAccountBenefitList.vue?vue&type=script&lang=js"
export * from "./ContinueAsGuestAccountBenefitList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__